module.exports = __webpack_public_path__ + "img/kknn03.ba2b302d.jpg";